import { UISDK } from "@/ui-sdk";

export default async function handleFloatingChat(
  element: HTMLElement,
  sdk: UISDK,
) {

  return sdk.renderFloatingChat(element);
}
